<template>

    <div>
        <div >
            <!--div class="container pt-5 d-none">
            <mdb-tabs class="col-5"
                    :active="0"
                    default
                      color="biletbul-bg-blue"
                    :links="[
                        { text: 'Ucuz Uçak Bileti Bul' },
                        { text: 'Charter Uçuşlar' },
                       ]"
                    :transition-duration="0.5"
                    transition-style="fade">

                <template :slot="'Ucuz Uçak Bileti Bul'" >
                    <mdb-container>
                        <mdb-jumbotron class="hoverable biletbul-bg-blue p-3">
                            <form class="search-form-vertical">
                                <div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" name="flight_type" class="custom-control-input" id="gidisDonus" checked>
                                        <label class="custom-control-label" for="gidisDonus">Gidiş - Dönüş</label>
                                    </div>

                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" name="flight_type" class="custom-control-input" id="tekYon">
                                        <label class="custom-control-label" for="tekYon">Tek yön</label>
                                    </div>

                                    <div class="custom-control custom-checkbox custom-control-inline">
                                        <input type="checkbox" class="custom-control-input" id="defaultInline3">
                                        <label class="custom-control-label" for="defaultInline3">Direkt uçuşları göster</label>
                                    </div>


                                </div>
                                <div class="form-group mb-0 ">
                                    <input type="text" id="from" class="form-control form-control-lg rd-0">
                                </div>
                                <div class="form-group">
                                    <input type="text" id="to" class="form-control form-control-lg rd-0">
                                </div>
                                <div class="row mb-2">
                                    <div class="col-6 pr-0">
                                        <input type="text" id="deparDate" class="form-control rd-0">
                                    </div>
                                    <div class="col-6 pl-0">
                                        <input type="text" id="arrivalDate" class="form-control rd-0">
                                    </div>
                                </div>
                                <div class="row ">
                                    <div class="col-8">
                                        <div class="form-group ">
                                            <input type="text" id="people" class="form-control ">
                                        </div>
                                    </div>
                                    <div class="col-4 pl-0">
                                        <mdb-btn color="biletbul-bg-red" class="m-0">Bilet Bul</mdb-btn>
                                    </div>
                                </div>
                            </form>
                        </mdb-jumbotron>
                    </mdb-container>
                </template>
                <template :slot="'Charter Uçuşlar'">
                    <mdb-container>
                        <mdb-jumbotron class="text-center hoverable biletbul-bg-blue">
                            <form>
                                <p class="h4 text-center mb-4">Write to us</p>
                            </form>
                        </mdb-jumbotron>
                    </mdb-container>
                </template>
            </mdb-tabs>
            </div-->


        </div>
        <div class="container mt-5 mb-5">
            <div class="row ">
                <bb-firstLeftSide class="col-12 col-md-6"></bb-firstLeftSide>
                <bb-firstRightSide class="col-12 col-md-6"></bb-firstRightSide>
            </div>
        </div>
        <div class="bilet-kampanya" id="kampanyalar">
            <div class="container  mt-3 p-0">
                <div class="">
                    <bb-centerKampanya></bb-centerKampanya>
                </div>
            </div>
        </div>
        <div class="area-background new-design">
            <div class="container mt-5 mb-5 p-0 ">
                <bb-centerSlide></bb-centerSlide>
                <div class="col-12 mt-5">
                    <div >
                        <bb-altKampanya></bb-altKampanya>
                    </div>
                </div>
            </div>
        </div>

        <div class="biletbul-bg-blue mt-4 d-none">
            <div class="container pb-4 pt-4">
                <div class="row d-none" >
                    <div class="col-12 col-md-2">
                        <mdb-icon icon="user-plus" size="2x" class="ml-2"/>
                        <mdb-icon icon="angle-double-right" size="2x" class="ml-2 amber-text"/>
                        <mdb-icon icon="user-check" size="3x" class="ml-2"/>
                    </div>
                    <div class="col-12 col-md-10">
                        <h4>Davet Et Kazan</h4>
                        <p>Biletbul.com’a üye olan kullanıcılar arkadaşlarını davet ederek veya tavsiye linkini paylaşarak, bu davete veya tavsiye linkine istinaden arkadaşlarının
                            üye olduktan sonra yaptığı ilk alışverişten 15 TL indirim kuponu kazanma fırsatı.</p>
                        <mdb-btn color="warning" size="sm">Detaylar <mdb-icon icon="angle-double-right" />
                        </mdb-btn>
                    </div>
                </div>
            </div>
        </div>



    </div>
</template>

<script>
    import { mdbStretchedLink,mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter,mdbContainer, mdbCol, mdbRow, mdbIcon, mdbTabs, mdbJumbotron, mdbView, mdbMask, mdbBtn, mdbTextarea, mdbInput, mdbCarousel, mdbCarouselItem,mdbCard, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText, mdbCarouselCaption } from 'mdbvue';
    import firstLeftSide from '@/components/firstLeftSide';
    import firstRightSide from '@/components/firstRightSide';
    import centerKampanya from '@/components/centerKampanya';
    import altKampanya from '@/components/altKampanya';
    import centerSlide from '@/components/centerSlide';
    import axios from "axios";

    export default {
        name: "mainPage",
        metaInfo() {
            return {
                title: "BiletBul.Com: Ucuz Uçak Bileti",
                meta: [
                    { name: 'description', content:  "İZMİR - ANTALYA. Biletbul.com. Tıklayın. Uygun Uçak Biletleri. Havayolu firmalarının sayısının artması ve firmalar arası rekabet ile "},
                    { name: 'keywords', content:  "ucuz,uçak,bilet,antalya uçak bileti"},
                    { property: 'og:title', content: "BiletBul.Com: Ucuz Uçak Bileti"},
                    { property: 'og:site_name', content: 'biletbul.com'},
                    {property: 'og:type', content: 'website'},
                    {name: 'robots', content: 'index,follow'}
                ]
            }
        },
        components: {
            mdbContainer,
            mdbCol,
            mdbRow,
            mdbIcon,
            mdbTabs,
            mdbJumbotron,
            mdbView,
            mdbMask,
            mdbBtn,
            mdbTextarea,
            mdbInput,
            mdbCarouselItem,
            mdbCard,
            mdbCardImage,
            mdbCardBody,
            mdbCardTitle,
            mdbCardText,
            mdbCarousel,
            mdbCarouselCaption,mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter,mdbStretchedLink,
            'bb-firstLeftSide':firstLeftSide,
            'bb-firstRightSide':firstRightSide,

            'bb-centerKampanya':centerKampanya,
            'bb-altKampanya':altKampanya,
            'bb-centerSlide':centerSlide,
        },
        data: () => ({

        altAlans : [
            {
                title:'Frankfurt, Almanya',
                route:'Antalya (AYT) - Frankfurt (FRA)',
                date:'1 Ekim - 6 Ekim (5 Gün)',
                price:'1385',
                info:'Aktarma yok',
                url:'#',

            },{
                title:'Frankfurt, Almanya',
                route:'Antalya (AYT) - Frankfurt (FRA)',
                date:'1 Ekim - 6 Ekim (5 Gün)',
                price:'1385',
                info:'Aktarma yok',
                url:'#',

            },{
                title:'Frankfurt, Almanya',
                route:'Antalya (AYT) - Frankfurt (FRA)',
                date:'1 Ekim - 6 Ekim (5 Gün)',
                price:'1385',
                info:'Aktarma yok',
                url:'#',

            },{
                title:'Frankfurt, Almanya',
                route:'Antalya (AYT) - Frankfurt (FRA)',
                date:'1 Ekim - 6 Ekim (5 Gün)',
                price:'1385',
                info:'Aktarma yok',
                url:'#',

            },{
                title:'Frankfurt, Almanya',
                route:'Antalya (AYT) - Frankfurt (FRA)',
                date:'1 Ekim - 6 Ekim (5 Gün)',
                price:'1385',
                info:'Aktarma yok',
                url:'#',

            },
        ]
        }),
        methods:{

        },
        mounted() {
            /*window.onbeforeunload = function (e) {
                let storage = window.localStorage;
                storage.clear()
            }*/
            //localStorage.clear();
            if(localStorage.sessionId){
                localStorage.removeItem("sessionId");
                localStorage.removeItem("sessionToken");
                localStorage.removeItem("departure_branded_code");
                localStorage.removeItem("departure_product_id");
                localStorage.removeItem("departure_commission");
                localStorage.removeItem("return_commission");
                localStorage.removeItem("departure_time");
                localStorage.removeItem("dp_product_id");
                localStorage.removeItem("dp_service_fee");
                localStorage.removeItem("return_time");
                localStorage.removeItem("rt_product_id");
                localStorage.removeItem("rt_service_fee");
                localStorage.removeItem("total_fares");
                localStorage.removeItem("sub_options");
                localStorage.removeItem("flightClass");
                localStorage.removeItem("departure_charter");
                localStorage.removeItem("arrival_charter");
                localStorage.removeItem("persons");
                localStorage.removeItem("amount_paid");
            }
            if(localStorage.departure_charter_id){
                localStorage.removeItem("departure_charter");
                localStorage.removeItem("departure_charter_id");
                localStorage.removeItem("arrival_charter");
                localStorage.removeItem("return_charter_id");
                localStorage.removeItem("persons");
                localStorage.removeItem("amount_paid");
            }
            if(localStorage.billing_name){
                localStorage.removeItem("billing_name");
                localStorage.removeItem("tax_office");
                localStorage.removeItem("tax_number");
                localStorage.removeItem("address_detail");
                localStorage.removeItem("zip_code");
                localStorage.removeItem("address_district");
                localStorage.removeItem("city");
            }
            if(localStorage.fromAirCode){
                localStorage.removeItem("fromAirCode");
                localStorage.removeItem("fromCountry");
                localStorage.removeItem("fromIsCity");
                localStorage.removeItem("fromCity");
                localStorage.removeItem("fromName");
                localStorage.removeItem("fromString");
                localStorage.removeItem("toAirCode");
                localStorage.removeItem("toCountry");
                localStorage.removeItem("toIsCity");
                localStorage.removeItem("toCity");
                localStorage.removeItem("toName");
                localStorage.removeItem("toStrings");
                localStorage.removeItem("dateOne");
                localStorage.removeItem("dateTwo");
                localStorage.removeItem("adultPerson");
                localStorage.removeItem("childPerson");
                localStorage.removeItem("babyPerson");
                localStorage.removeItem("flightType");
                localStorage.removeItem("flightClass");
            }
            if(localStorage.newsletter_agreement){
                this.newsletter_agreement = localStorage.newsletter_agreement;
            }
        }
    }
</script>

<style >
.search-form{
    border-top-left-radius: 0!important;
}
</style>
